import pluralize from 'pluralize';

import {
  ComponentLinkItem,
  ComponentLinkItemNarrow,
} from '../shared/component-parts';
import { ViewProps } from './guided-research.constants';
import { getRegionalisedLink } from 'approot/shared/logic/get-regionalised-link';
import { COMPONENT_LAYOUT_LIST } from 'global/constants';

const GuidedResearchView = (
  props: ViewProps & { onStimulusOpen?: () => void }
) => {
  if (!props.stimulusResourceProperties) return null;

  const componentLinkItemProps = {
    primaryText: props.stimulusResourceProperties.resourceName,
    squareImage: props.stimulusResourceProperties.coverImage,
    link: getRegionalisedLink(props.stimulusResourceProperties.slug || ''),
    textBadge: `${props.stimulusResourceProperties.links.length} ${pluralize(
      'link',
      props.stimulusResourceProperties.links.length
    )}`,
    onClick: props.onStimulusOpen,
  };

  return (
    <>
      {props.properties.layout?.display === COMPONENT_LAYOUT_LIST ? (
        <ComponentLinkItemNarrow {...componentLinkItemProps} />
      ) : (
        <ComponentLinkItem {...componentLinkItemProps} />
      )}
    </>
  );
};

export default GuidedResearchView;
